import React from 'react'
import { Link } from 'react-router-dom'
import { appDevelopmentSubtypesByType } from './appDevelopmentSubtypeContent'

const AppDevelopmentSubtypes = ({ typeKey, currentSubtypeSlug, eyebrow, heading, intro }) => {
  const group = appDevelopmentSubtypesByType[typeKey]
  if (!group) return null

  return (
    <section className="app-development-types py-5" aria-labelledby={`${typeKey}-app-development-subtypes-heading`}>
      <div className="container">
        <div className="text-center mb-4">
          <h2 className="h5 fw-bold text-white" style={{}}>
            {eyebrow || 'SPECIALIST SOLUTIONS'}
          </h2>
          <h2 id={`${typeKey}-app-development-subtypes-heading`} className="display-5 fw-bold text-light">
            {heading || `Types Of ${group.title} We Offer`}
          </h2>
          <p className="lead text-light text-opacity-75 mx-auto" style={{ maxWidth: 820 }}>
            {intro || `Compare focused product models within ${group.title.toLowerCase()}, each planned around its users, workflows, integrations, controls, and operating evidence.`}
          </p>
        </div>

        <div className="row">
          {group.subtypes.map((subtype) => {
            const isCurrent = subtype.slug === currentSubtypeSlug
            return (
              <div key={subtype.path} className="col-lg-3 col-md-6 col-12 my-2">
                <Link
                  to={`${subtype.path}/`}
                  className="text-decoration-none"
                  onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'instant' })}
                  aria-label={`${isCurrent ? 'Current service: ' : 'Learn about '}${subtype.pageTitle}`}
                  aria-current={isCurrent ? 'page' : undefined}
                >
                  <article
                    className="card app-development-type-card h-100 overflow-hidden rounded-4 text-light"
                    style={{
                      backgroundColor: '#0f0f12',
                      border: `1px solid ${isCurrent ? '#8f8fff' : 'rgba(101, 101, 255, .55)'}`
                    }}
                  >
                    <div className="app-development-type-card-image">
                      <img
                        src={subtype.image}
                        data-fallback-src={subtype.fallbackImage}
                        onError={(event) => {
                          if (event.currentTarget.src !== subtype.fallbackImage) {
                            event.currentTarget.src = subtype.fallbackImage
                          }
                        }}
                        className="w-100 h-100"
                        alt={`${subtype.pageTitle} services`}
                        loading="lazy"
                      />
                    </div>
                    <div className="card-body d-flex flex-column p-4">
                      <h3 className="h5 fw-bold">{subtype.title}</h3>
                      <p className="text-light text-opacity-75 mb-4">{subtype.summary}</p>
                      <span className="mt-auto" style={{ color: '#8f8fff' }}>
                        {isCurrent ? 'Current service' : 'Explore service'}{' '}
                        <i className="fa fa-arrow-right ms-2" aria-hidden="true"></i>
                      </span>
                    </div>
                  </article>
                </Link>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default AppDevelopmentSubtypes
